/** Store → Customers list. */
import { ExportCustomersButton } from './ShopExports';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Empty, Input, Table, Tag, Typography } from 'antd';
import { useTranslation } from '../../../shared/i18n';
import { fmtDate, listOf, money, sitePath, toastErr, totalOf, useSite } from './common';

const { Text } = Typography;

const Customers = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { api, siteId, currency } = useSite();
    const [f, setF] = useState({ q: '', page: 1, per_page: 25 });
    const [q, setQ] = useState('');
    const [data, setData] = useState({ items: [], total: 0 });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let live = true;
        setLoading(true);
        api.get('/customers', Object.fromEntries(Object.entries(f).filter(([, v]) => v !== '')))
            .then((d) => live && setData({ items: listOf(d), total: totalOf(d) }))
            .catch((e) => { if (live) { if (e.status !== 404) toastErr(e); setData({ items: [], total: 0 }); } })
            .finally(() => live && setLoading(false));
        return () => { live = false; };
    }, [api, f]);

    return (
        <Card title={t('Customers')} extra={<ExportCustomersButton />}>
            <Input.Search allowClear placeholder={t('Search name or email')} value={q} onChange={(e) => setQ(e.target.value)}
                onSearch={(v) => setF((x) => ({ ...x, q: v, page: 1 }))} style={{ maxWidth: 320, marginBottom: 12 }} />
            <Table
                rowKey="id"
                loading={loading}
                dataSource={data.items}
                scroll={{ x: 760 }}
                onRow={(c) => ({ onClick: () => navigate(sitePath(siteId, `customers/${c.id}`)), style: { cursor: 'pointer' } })}
                pagination={{ current: f.page, pageSize: f.per_page, total: data.total, hideOnSinglePage: true, onChange: (page, per) => setF((x) => ({ ...x, page, per_page: per })) }}
                columns={[
                    {
                        title: t('Customer'), key: 'n', render: (_, c) => (
                            <div>
                                <a>{c.name || c.email}</a>
                                {c.name && <div><Text type="secondary" style={{ fontSize: 12 }}>{c.email}</Text></div>}
                            </div>
                        ),
                    },
                    { title: t('Account'), key: 'acc', width: 120, render: (_, c) => (c.state === 'disabled' ? <Tag>{t('Disabled')}</Tag> : c.has_account || c.registered ? <Tag color="blue">{t('Registered')}</Tag> : <Tag>{t('Guest')}</Tag>) },
                    { title: t('Marketing'), dataIndex: 'accepts_marketing', width: 110, render: (v) => (v ? <Tag color="green">{t('Subscribed')}</Tag> : <Text type="secondary">-</Text>) },
                    { title: t('Orders'), dataIndex: 'orders_count', width: 90 },
                    { title: t('Amount spent'), dataIndex: 'total_spent', width: 130, align: 'right', render: (v) => money(v || 0, currency) },
                    { title: t('Since', { context: 'shop' }), dataIndex: 'created_at', width: 120, responsive: ['lg'], render: (v) => fmtDate(v, false) },
                ]}
                locale={{ emptyText: <Empty description={f.q ? t('No customers match') : t('No customers yet')} /> }}
            />
        </Card>
    );
};

export default Customers;
